// This file is automatically generated. DO NOT EDIT.

import { type TextResponse } from '../../../../types/response/TextResponse';
import { getJSONResponse, type GetJSONResponseOptions } from '@api/internal';

export interface GetTextResponsesResponse {
  /** The responses */
  responses: Array<TextResponse>;
  /** The number of upvoters */
  upvoterCount: number;
}

export async function getTextResponsesResponse(
  response: Response,
  options?: GetJSONResponseOptions<GetTextResponsesResponse>,
): Promise<GetTextResponsesResponse> {
  return getJSONResponse<GetTextResponsesResponse>(
    response,
    'getTextResponsesResponse',
    options,
  );
}
